import type { MetodoPago } from '../gastos/types';
import type { MetodoCierre } from './types';

/** Mapea método de cierre → enum `gastos.metodo_pago` en Supabase. */
export function cierreMetodoToGastoEnum(m: MetodoCierre): MetodoPago {
  switch (m) {
    case 'efectivo':
      return 'efectivo';
    case 'banco':
      return 'transferencia';
    case 'nequi':
      return 'nequi';
    case 'daviplata':
      return 'daviplata';
    case 'tarjeta':
      return 'tarjeta_debito';
    default:
      return 'otro';
  }
}
